export default __webpack_public_path__ + "static/media/Logo_01.55c433e8.png";